// Note: This entire file can be deleted once it is no longer used by serverSettingsMixin.pug
import { Module } from '../Module';

export interface IPadFilter {
  (numberToPad: number, length: number): string;
}

// See http://stackoverflow.com/a/21712550 for an explanation
Module.instance().filter('pad', (): IPadFilter => {
  return (numberToPad: number, length: number) => {
    return (1e4 + numberToPad + '').slice(-length);
  };
});
